import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createBlock as _createBlock, unref as _unref, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { style: {"display":"flex","align-items":"center","gap":"16px","margin-bottom":"16px"} }
const _hoisted_3 = { class: "form-item-content" }
const _hoisted_4 = { class: "form-item-content" }
const _hoisted_5 = { class: "form-item-content" }
const _hoisted_6 = { class: "form-item-content" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 3,
  style: {"display":"flex","gap":"8px"}
}
const _hoisted_14 = { key: 6 }

import { onMounted, reactive, ref } from "vue";
import { message } from "ant-design-vue";
import { ToImage } from "@/utils/image";
import dayjs from "dayjs";
import { ColumnType } from "ant-design-vue/lib/table";
import { Template } from "@/api/models/template/Template";
import { SupervisorService } from "@/api/services/SupervisorService";
import { SupervisorListRequest } from "@/api/models/supervisor/SupervisorListRequest";
import { Supervisor } from "@/api/models/supervisor/Supervisor";
import { SupervisorAddRequest } from "@/api/models/supervisor/SupervisorAddRequest";
import { SupervisorUpdateRequest } from "@/api/models/supervisor/SupervisorUpdateRequest";


export default /*@__PURE__*/_defineComponent({
  __name: 'SupervisorView',
  setup(__props) {

const total = ref<number>(0);

const listRequest = reactive<SupervisorListRequest>({
  current: 1,
  size: 20,
  content: "",
  province: "",
  city: "",
  district: "",
});

// @ts-ignore
const supervisorList = ref<Supervisor[]>([{}]);

const copyContent = async (content: string) => {
  await navigator.clipboard.writeText(content);
  message.success("复制成功");
};

const handleList = async () => {
  const res = await SupervisorService.ListAll(listRequest);
  if (res.code === 0) {
    supervisorList.value = res.data.records;
    total.value = res.data.total;
  } else {
    message.error(res.msg);
  }
};

onMounted(async () => {
  await handleList();
});

const resetSearch = () => {
  listRequest.current = 1;
  listRequest.size = 20;
  listRequest.content = "";
  listRequest.province = "";
  listRequest.city = "";
  listRequest.district = "";
  listRequest.category = undefined;
  handleList();
};

const handleSizeChange = (current: number, pageSize: number) => {
  listRequest.current = current;
  listRequest.size = pageSize;
  handleList();
};

const handleChange = (page: number, pageSize: number) => {
  listRequest.current = page;
  listRequest.size = pageSize;
  handleList();
};

const openAdd = ref(false);

const addRequest = reactive<SupervisorAddRequest>({
  name: "",
  phone: "",
  province: "",
  city: "",
  district: "",
  address: "",
  is_right: 1,
  is_connect: 1,
  communication: [],
  content: "",
});

const submitAdd = async () => {
  const res = await SupervisorService.Add(addRequest);
  if (res.code === 0) {
    message.success("添加成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const openUpdate = ref(false);

const updateRequest = reactive<SupervisorUpdateRequest>({
  id: 0,
  is_delete: 0,
  name: "",
  phone: "",
  province: "",
  city: "",
  district: "",
  address: "",
  category: 0,
  is_right: 0,
  is_connect: 0,
  communication: [],
  content: "",
});

const handleUpdate = (record: Template) => {
  openUpdate.value = true;
  Object.assign(updateRequest, record);
};

const submitUpdate = async () => {
  const res = await SupervisorService.Update(updateRequest);
  if (res.code === 0) {
    message.success("修改成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const submitDelete = async (record: Template) => {
  const res = await SupervisorService.Delete(record.id);
  if (res.code === 0) {
    message.success("删除成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const submitDrop = async (record: Template) => {
  const res = await SupervisorService.Drop(record.id);
  if (res.code === 0) {
    message.success("删除成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const columns: ColumnType[] = [
  {
    title: "Id",
    dataIndex: "id",
    align: "center",
  },
  {
    title: "名称",
    dataIndex: "name",
    align: "center",
  },
  {
    title: "省份",
    dataIndex: "province",
    align: "center",
  },
  {
    title: "城市",
    dataIndex: "city",
    align: "center",
  },
  {
    title: "县区",
    dataIndex: "district",
    align: "center",
  },
  {
    title: "地址",
    dataIndex: "address",
    align: "center",
  },
  {
    title: "分类",
    dataIndex: "category",
    align: "center",
  },
  {
    title: "地址是否正确",
    dataIndex: "is_right",
    align: "center",
  },
  {
    title: "未判决去人可以通信",
    dataIndex: "is_connect",
    align: "center",
  },
  {
    title: "通讯方式",
    dataIndex: "communication",
    align: "center",
    width: 250,
  },
  {
    title: "其它补充",
    dataIndex: "content",
    align: "center",
  },
  {
    title: "状态",
    dataIndex: "is_delete",
    align: "center",
  },
  {
    title: "创建时间",
    dataIndex: "create_at",
    align: "center",
  },
  {
    title: "操作",
    dataIndex: "operator",
    align: "center",
    width: 300,
  },
];

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_form, {
        model: handleList,
        class: "search-form",
        onSubmit: handleList
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (openAdd.value = true)),
                style: {"margin-bottom":"0"}
              }, {
                default: _withCtx(() => _cache[31] || (_cache[31] = [
                  _createTextVNode(" 添加监所 ")
                ])),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _cache[34] || (_cache[34] = _createElementVNode("div", { class: "label" }, "类别：", -1)),
                _createVNode(_component_a_select, {
                  style: {"width":"100px"},
                  value: listRequest.category,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((listRequest.category) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: 1 }, {
                      default: _withCtx(() => _cache[32] || (_cache[32] = [
                        _createTextVNode("监所")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 2 }, {
                      default: _withCtx(() => _cache[33] || (_cache[33] = [
                        _createTextVNode("看守所")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _cache[35] || (_cache[35] = _createElementVNode("div", { class: "label" }, "省份：", -1)),
                _createVNode(_component_a_input, {
                  placeholder: "省份",
                  value: listRequest.province,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((listRequest.province) = $event))
                }, null, 8, ["value"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _cache[36] || (_cache[36] = _createElementVNode("div", { class: "label" }, "城市：", -1)),
                _createVNode(_component_a_input, {
                  placeholder: "省份",
                  value: listRequest.city,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((listRequest.city) = $event))
                }, null, 8, ["value"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _cache[37] || (_cache[37] = _createElementVNode("div", { class: "label" }, "县区：", -1)),
                _createVNode(_component_a_input, {
                  placeholder: "省份",
                  value: listRequest.district,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((listRequest.district) = $event))
                }, null, 8, ["value"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                "html-type": "submit"
              }, {
                default: _withCtx(() => _cache[38] || (_cache[38] = [
                  _createTextVNode("搜索")
                ])),
                _: 1
              }),
              _createVNode(_component_a_button, {
                style: {"margin-left":"10px"},
                onClick: resetSearch
              }, {
                default: _withCtx(() => _cache[39] || (_cache[39] = [
                  _createTextVNode("重置 ")
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_a_table, {
      columns: columns,
      "data-source": supervisorList.value,
      pagination: {
        current: listRequest.current,
        pageSize: listRequest.size,
        total: total.value,
        showSizeChanger: true,
        pageSizeOptions: [10, 20, 30, 40, 50],
        onChange: handleChange,
        onShowSizeChange: handleSizeChange,
      },
      scroll: { x: 2300, y: 800 },
      bordered: ""
    }, {
      bodyCell: _withCtx(({ column, record }) => [
        (column.dataIndex === 'category')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (record.category === 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "监所"))
                : _createCommentVNode("", true),
              (record.category === 2)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "看守所"))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (column.dataIndex === 'is_right')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (record.is_right === 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, "已确认"))
                : _createCommentVNode("", true),
              (record.is_right === 2)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, "暂未确认"))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (column.dataIndex === 'is_connect')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              (record.is_connect === 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, "已确认"))
                : _createCommentVNode("", true),
              (record.is_connect === 2)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, "暂未确认"))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (column.dataIndex === 'communication')
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              (record.communication && record.communication.includes(1))
                ? (_openBlock(), _createBlock(_component_a_tag, {
                    key: 0,
                    color: "green"
                  }, {
                    default: _withCtx(() => _cache[40] || (_cache[40] = [
                      _createTextVNode("明信片 ")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (record.communication && record.communication.includes(2))
                ? (_openBlock(), _createBlock(_component_a_tag, {
                    key: 1,
                    color: "blue"
                  }, {
                    default: _withCtx(() => _cache[41] || (_cache[41] = [
                      _createTextVNode("普通信件 ")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (record.communication && record.communication.includes(3))
                ? (_openBlock(), _createBlock(_component_a_tag, {
                    key: 2,
                    color: "red"
                  }, {
                    default: _withCtx(() => _cache[42] || (_cache[42] = [
                      _createTextVNode("EMS ")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
          : (column.dataIndex === 'image_url')
            ? (_openBlock(), _createBlock(_component_a_image, {
                key: 4,
                src: _unref(ToImage)(record.image_url),
                style: {"height":"60px","width":"auto"}
              }, null, 8, ["src"]))
            : (column.dataIndex === 'is_delete')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                  (record.is_delete === 1)
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 0,
                        color: "green"
                      }, {
                        default: _withCtx(() => _cache[43] || (_cache[43] = [
                          _createTextVNode("正常")
                        ])),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (record.is_delete === 2)
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 1,
                        color: "red"
                      }, {
                        default: _withCtx(() => _cache[44] || (_cache[44] = [
                          _createTextVNode("回收站")
                        ])),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ], 64))
              : (column.dataIndex === 'create_at')
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_unref(dayjs)(record.create_at).format("YYYY-MM-DD HH:mm:ss")), 1))
                : (column.dataIndex === 'operator')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                      _createVNode(_component_a_button, {
                        onClick: ($event: any) => (handleUpdate(record)),
                        type: "primary",
                        style: { marginRight: '8px' }
                      }, {
                        default: _withCtx(() => _cache[45] || (_cache[45] = [
                          _createTextVNode("编辑 ")
                        ])),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createVNode(_component_a_button, {
                        onClick: ($event: any) => (submitDelete(record)),
                        type: "primary",
                        style: {
              backgroundColor: '#ff7a45',
              color: 'white',
              marginRight: '8px',
            }
                      }, {
                        default: _withCtx(() => _cache[46] || (_cache[46] = [
                          _createTextVNode("删除 ")
                        ])),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createVNode(_component_a_button, {
                        onClick: ($event: any) => (submitDrop(record)),
                        type: "primary",
                        style: {
              backgroundColor: '#ff4d4f',
              color: 'white',
            }
                      }, {
                        default: _withCtx(() => _cache[47] || (_cache[47] = [
                          _createTextVNode("彻底删除 ")
                        ])),
                        _: 2
                      }, 1032, ["onClick"])
                    ], 64))
                  : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["data-source", "pagination"]),
    _createVNode(_component_a_modal, {
      open: openAdd.value,
      "onUpdate:open": _cache[17] || (_cache[17] = ($event: any) => ((openAdd).value = $event)),
      title: "添加监所数据",
      onOk: submitAdd,
      cancelText: "取消"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, { model: addRequest }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: addRequest.name,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((addRequest.name) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "电话" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: addRequest.phone,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((addRequest.phone) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "省份" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: addRequest.province,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((addRequest.province) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "城市" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: addRequest.city,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((addRequest.city) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "县区" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: addRequest.district,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((addRequest.district) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "地址" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  value: addRequest.address,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((addRequest.address) = $event)),
                  "auto-size": { minRows: 2, maxRows: 5 }
                }, null, 8, ["value"]),
                _createVNode(_component_a_button, {
                  type: "primary",
                  size: "small",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (copyContent(addRequest.address)))
                }, {
                  default: _withCtx(() => _cache[48] || (_cache[48] = [
                    _createTextVNode(" 一键复制 ")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "类别" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: addRequest.category,
                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((addRequest.category) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: 1 }, {
                      default: _withCtx(() => _cache[49] || (_cache[49] = [
                        _createTextVNode("监所")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 2 }, {
                      default: _withCtx(() => _cache[50] || (_cache[50] = [
                        _createTextVNode("看守所")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "地址是否确认" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: addRequest.is_right,
                  "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((addRequest.is_right) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: 1 }, {
                      default: _withCtx(() => _cache[51] || (_cache[51] = [
                        _createTextVNode("已确认")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: 2 }, {
                      default: _withCtx(() => _cache[52] || (_cache[52] = [
                        _createTextVNode("暂未确认")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "未判决去人可以通信" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: addRequest.is_connect,
                  "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((addRequest.is_connect) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: 1 }, {
                      default: _withCtx(() => _cache[53] || (_cache[53] = [
                        _createTextVNode("已确认")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: 2 }, {
                      default: _withCtx(() => _cache[54] || (_cache[54] = [
                        _createTextVNode("暂未确认")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "通讯方式" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_checkbox_group, {
                  value: addRequest.communication,
                  "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((addRequest.communication) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_checkbox, { value: 1 }, {
                      default: _withCtx(() => _cache[55] || (_cache[55] = [
                        _createTextVNode("明信片")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_checkbox, { value: 2 }, {
                      default: _withCtx(() => _cache[56] || (_cache[56] = [
                        _createTextVNode("普通信件")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_checkbox, { value: 3 }, {
                      default: _withCtx(() => _cache[57] || (_cache[57] = [
                        _createTextVNode("EMS")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "补充内容" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  value: addRequest.content,
                  "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((addRequest.content) = $event)),
                  "auto-size": { minRows: 2, maxRows: 5 }
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_a_modal, {
      open: openUpdate.value,
      "onUpdate:open": _cache[30] || (_cache[30] = ($event: any) => ((openUpdate).value = $event)),
      title: "修改监所数据",
      onOk: submitUpdate,
      cancelText: "取消"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: updateRequest,
          style: {"margin-top":"20px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: updateRequest.name,
                  "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((updateRequest.name) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "电话" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: updateRequest.phone,
                  "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((updateRequest.phone) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "省份" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: updateRequest.province,
                  "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((updateRequest.province) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "城市" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: updateRequest.city,
                  "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((updateRequest.city) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "县区" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: updateRequest.district,
                  "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((updateRequest.district) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "地址" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  value: updateRequest.address,
                  "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((updateRequest.address) = $event)),
                  "auto-size": { minRows: 2, maxRows: 5 }
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "类别" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: updateRequest.category,
                  "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((updateRequest.category) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: 1 }, {
                      default: _withCtx(() => _cache[58] || (_cache[58] = [
                        _createTextVNode("监所")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 2 }, {
                      default: _withCtx(() => _cache[59] || (_cache[59] = [
                        _createTextVNode("看守所")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "地址是否确认" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: updateRequest.is_right,
                  "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((updateRequest.is_right) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: 1 }, {
                      default: _withCtx(() => _cache[60] || (_cache[60] = [
                        _createTextVNode("已确认")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: 2 }, {
                      default: _withCtx(() => _cache[61] || (_cache[61] = [
                        _createTextVNode("暂未确认")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "未判决去人可以通信" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: updateRequest.is_connect,
                  "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((updateRequest.is_connect) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: 1 }, {
                      default: _withCtx(() => _cache[62] || (_cache[62] = [
                        _createTextVNode("已确认")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: 2 }, {
                      default: _withCtx(() => _cache[63] || (_cache[63] = [
                        _createTextVNode("暂未确认")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "通讯方式" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_checkbox_group, {
                  value: updateRequest.communication,
                  "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((updateRequest.communication) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_checkbox, { value: 1 }, {
                      default: _withCtx(() => _cache[64] || (_cache[64] = [
                        _createTextVNode("明信片")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_checkbox, { value: 2 }, {
                      default: _withCtx(() => _cache[65] || (_cache[65] = [
                        _createTextVNode("普通信件")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_checkbox, { value: 3 }, {
                      default: _withCtx(() => _cache[66] || (_cache[66] = [
                        _createTextVNode("EMS")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "补充内容" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  value: updateRequest.content,
                  "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((updateRequest.content) = $event)),
                  "auto-size": { minRows: 2, maxRows: 5 }
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "状态" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: updateRequest.is_delete,
                  "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((updateRequest.is_delete) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: 0 }, {
                      default: _withCtx(() => _cache[67] || (_cache[67] = [
                        _createTextVNode("\"")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 1 }, {
                      default: _withCtx(() => _cache[68] || (_cache[68] = [
                        _createTextVNode("正常")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 2 }, {
                      default: _withCtx(() => _cache[69] || (_cache[69] = [
                        _createTextVNode("回收站")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["open"])
  ]))
}
}

})